module.exports = __webpack_public_path__ + "static/media/WhatsApp_Cadillac-EN.7d4fd3f4.png";